import { render, staticRenderFns } from "./gulou.vue?vue&type=template&id=675026ee"
import script from "./gulou.vue?vue&type=script&lang=js"
export * from "./gulou.vue?vue&type=script&lang=js"
import style0 from "./gulou.vue?vue&type=style&index=0&id=675026ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports